import React from 'react';
import PropTypes from 'prop-types';
import StepControlButtons from '../UI/StepControlButtons';
import { Translate } from 'react-localize-redux';
import Image from '../../../assets/images/communities-wizard-final-page.png';

export default class FinalStep extends React.Component {
	static propTypes = {
		previousStep: PropTypes.func,
	};

	render() {
		return (
			<div className="wizard-content">
				<h1>
					<Translate id="community_wizard_get_started" />
				</h1>
				<p>
					<Translate id="community_wizard_all_set" />
				</p>
				<img
					src={Image}
					alt="Communities page"
					id="wizard-final-step-image"
				/>
				<p>
					<Translate
						id="community_wizard_questions"
						options={{ renderInnerHtml: true }}
					/>
				</p>
				<StepControlButtons
					goBack={this.props.previousStep}
					submit={this.completeWizard}
					submitId="affiliation-wizard-submit"
				/>
			</div>
		);
	}

	completeWizard() {
		var url =
			window.location !== window.parent.location
				? document.referrer
				: document.location.href;
		var data = {
			action: 'wizard::community::complete',
		};

		window.parent.postMessage(JSON.stringify(data), url);
	}
}
